import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import Color from 'color'
import { Fonts, Button } from 'components/base-ui'
import { useTranslation } from 'react-i18next'
import { AppContext } from 'contexts/AppProvider'

interface NoneMembershipHatoHeartProps {
  brandLogo: string
  vendorName: string
  onRegisterMemberpship: () => void
  onConnectMembership: () => void
}

const NoneMembershipHatoHeart: FC<NoneMembershipHatoHeartProps> = ({
  onRegisterMemberpship,
  onConnectMembership,
  brandLogo,
  vendorName,
}) => {
  const { isThaiLang } = useContext(AppContext)
  const { t } = useTranslation()
  const imageBg = `${process.env.PUBLIC_URL}/assets/hato-heart/hand.png`

  return (
    <Wrapper>
      <Background>
        <BgHand src={imageBg} />
        <BgHandColor />
      </Background>
      <Content>
        <Row>
          <Logo src={brandLogo} />
          <Title>
            <Fonts.H4>{`${t('dineInMemberTitle', { vendorName })}`}</Fonts.H4>
            <Fonts.H4>{`${t('dineInGetBenefit')}`}!</Fonts.H4>
          </Title>
        </Row>
        <Row>
          <ButtonWrapper>
            <ConnectMembershipButton xtra_sssm onClick={onRegisterMemberpship} isThaiLang={isThaiLang}>
              {t('genericRegisterMembership')}
            </ConnectMembershipButton>
            <ConnectMembershipButton xtra_sssm outline onClick={onConnectMembership} isThaiLang={isThaiLang}>
              {t('genericConnectMembership')}
            </ConnectMembershipButton>
          </ButtonWrapper>
        </Row>
      </Content>
    </Wrapper>
  )
}

export default NoneMembershipHatoHeart

const Wrapper = styled.div`
  width: 100%;
  height: 170px;
`

const Background = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  ${({ theme }) => `
  background-image: linear-gradient(
    135deg,
    ${Color(theme.colors.primary).alpha(0.3).string()},
    ${Color(theme.colors.primary).alpha(0.05).string()} 30%,
    ${theme.colors.white} 50%,
    ${Color(theme.colors.primary).alpha(0.1).string()}
  );`}
  border-radius: 16px;
  overflow: hidden;
`

const BgHandColor = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  mix-blend-mode: color;
`

const BgHand = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  filter: grayscale(1);
`

const Content = styled.div`
  position: inherit;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.M};
  padding: 22px;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(0%, -100%);
`

const Logo = styled.img`
  width: 56px;
  min-width: 56px;
  height: 56px;
  min-height: 56px;
  object-fit: contain;
  object-position: center;
  border-radius: ${({ theme }) => theme.radius.fullyRounded};
`

const Row = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing['3XL']};
`

const Title = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.base};

  @media (max-width: 371px) {
    h4 {
      font-size: 13px !important;
    }
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  row-gap: ${({ theme }) => theme.spacing['2XS']};

  button {
    max-width: fit-content;
    border-radius: 85px;
    height: 30px;
  }
`
const ConnectMembershipButton = styled(Button)<{ isThaiLang: boolean }>`
  font-size: 15px !important;
  font-weight: bold;
  min-width: ${({ isThaiLang }) => (isThaiLang ? '160px' : '200px')} !important;
`
